import { reactive } from 'vue'
import { normalizeGridTreeColumnProps } from './column/seq-column'
import type { GridColumnProps, GridQueryParams, GridTreeOptions } from './types'

export type GridTreeOptionConfig = Omit<
  GridTreeOptions,
  'queryByExamplePage' | 'getCurrentRow' | 'currentRow'
>

export class GridTreeOption {
  module!: string
  columns!: GridColumnProps[]
  tree?: GridTreeOptions['tree']
  queryByExamplePage!: (overrideParams?: GridQueryParams) => Promise<void>
  getCurrentRow!: () => Record<string, unknown> | null

  constructor(config: GridTreeOptionConfig) {
    if (!config.module) {
      throw new Error('[GridTreeOption] module is required')
    }
    if (!config.columns?.length) {
      throw new Error('[GridTreeOption] columns is required')
    }
    Object.assign(this, {
      ...config,
      tree: {
        parentField: 'parentId',
        rootParentValue: 0,
        rowField: 'id',
        indent: 18,
        expandAll: false,
        showLine: true,
        showRootLine: true,
        ...config.tree,
      },
      columns: normalizeGridTreeColumnProps(config.columns),
      autoQuery: config.autoQuery ?? true,
      loadAll: config.loadAll ?? true,
      pagination: config.pagination ?? true,
      getCurrentRow: () => null,
      queryByExamplePage: async () => {},
    })
    return reactive(this) as this
  }
}

declare global {
  // eslint-disable-next-line no-var
  var GridTreeOption: typeof GridTreeOption | undefined
}

if (typeof globalThis !== 'undefined') {
  globalThis.GridTreeOption = GridTreeOption
}
